import { useApiClient } from "../../../shared/customHooks";
import { FormikProps } from "formik";
import { useApplicationContext } from "../context/applicationContext";
import { childForm } from "../../../shared/formObjects/application/childForm";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ChildComponent({ disabled, data }: any) {
  function getInitalValues(initialData: any, formik: FormikProps<any>) {
    formik.setFieldValue("isInternal", true);
  }

  const api = useApiClient("Child");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={childForm}
      headerLabel="Child Demographic Information"
      editPath="child"
      apiClient={api}
      disabled={disabled}
      data={data}
      getInitialValues={getInitalValues}
      id={id}
      showInternalNotes={false}
    />
  );
}

export default ChildComponent;
